import React, { useEffect, useState } from "react";
import { FlatList, ScrollView, StyleSheet, Text, View } from "react-native";
import { globalFontStyle } from "../../assets";
import Colors from "../../assets/Color/Colors";
import Header from "../../commonComponents/Header";
import * as Progress from "react-native-progress";
import Width from "../../assets/Width";
import { proBanner } from "../../utils/images";
import { Network } from "../../utils/network";
import moment from "moment";
import { useDispatch } from "react-redux";
import { useSafeAreaInsets } from "react-native-safe-area-context";

import {
  hideLoader,
  showLoader,
} from "../../commonComponents/Loader/loader.actions";
import FastImage from "../../common/FastImage";
import FormTextLabel from "../../commonComponents/FormTextLabel";

/*const obj = {
  incentives: [
    {
      label: 'Level 1',
      qualifyingShares: 22,
      rewards: 11,
    },
  ],
  status: {
    curLevel: 'Level 3',
    curLevelReward: '500',
    curShares: 122,
    nextLevel: 'Unlock Level 2',
    nextLevelShares: 300,
    levelResetTime: '',
    totalRewardsEarned: 3465,
  },
  todayEvents: ['hello'],
  termAndConditions: ['22', '11'],
};*/

const ProTrader = ({ navigation }) => {
  const dispatch = useDispatch();
  const insets = useSafeAreaInsets();
  const [proTraderDetails, setProTraderDetails] = useState({});
  useEffect(() => {
    getProTraderData();
  }, []);

  const getProTraderData = async () => {
    dispatch(showLoader());
    const res = await Network.fetchProTraderData();
    if (res?.data) {
      setProTraderDetails(res?.data);
    }
    dispatch(hideLoader());
  };
  return (
    <ScrollView
      style={{
        paddingTop: insets.top,
        paddingBottom: insets.bottom,
        paddingLeft: insets.left,
        paddingRight: insets.right,
      }}
      showsVerticalScrollIndicator={false}
      contentContainerStyle={{
        flexGrow: 1,
        backgroundColor: Colors.bgWhite,
      }}
    >
      <View style={{ backgroundColor: Colors.tradexBlue }}>
        <Header
          isInternalPage={false}
          navigation={navigation}
          pageName="Pro Trader Incentives"
          customHeaderText={{ color: Colors.bgWhite }}
          isBackgroundColor={true}
          backGroundColor={Colors.tradexBlue}
          translate={true}
        />
      </View>

      <View
        style={{
          backgroundColor: Colors.tradexBlue,
          paddingHorizontal: 15,
          paddingBottom: 20,
        }}
      >
        <FastImage
          style={{ width: Width.width - 30, height: 65 }}
          source={proBanner()}
        />
        <View style={[styles.box, { backgroundColor: "white", marginTop: 10 }]}>
          <View
            style={{
              flexDirection: "row",
              marginBottom: 15,
              borderBottomWidth: 0.5,
            }}
          >
            <FormTextLabel labelStyles={[styles.colStyle, styles.headerCol]} label={"Level"}/>
            <FormTextLabel
              labelStyles={[
                styles.colStyle,
                styles.center,
                styles.headerCol,
                { flex: 1.5 },
              ]}
              label={"Qualifying shares (Qty)"}
            />
            <FormTextLabel
              labelStyles={[styles.colStyle, styles.right, styles.headerCol]}
              label={"Rewards"}
            />
          </View>
          <View
            style={{
              maxHeight: 220,
              //borderWidth: 0.5,
              //borderRadius: 5,
              marginBottom: 10,
            }}
          >
            <FlatList
              nestedScrollEnabled={true}
              data={proTraderDetails?.incentives}
              renderItem={({ item }) => {
                return (
                  <View style={{ flexDirection: "row", alignItems: "center" }}>
                    <Text style={[styles.colStyle, styles.rowTxt]}>
                      {item?.label}
                    </Text>
                    <Text
                      style={[styles.colStyle, styles.center, styles.rowTxt]}
                    >
                      {item?.qualifyingShares}
                    </Text>
                    <Text
                      style={[styles.colStyle, styles.right, styles.rowTxt]}
                    >
                      {item?.rewards}
                    </Text>
                  </View>
                );
              }}
              keyExtractor={(item, index) => item?.level}
              showsVerticalScrollIndicator={false}
              initialNumToRender={10}
            />
          </View>
        </View>
      </View>
      <View style={{ paddingHorizontal: 15, marginBottom: 30 }}>
        <View style={styles.box}>
          <View
            style={{ flexDirection: "row", justifyContent: "space-between" }}
          >
            <Text style={styles.levelBlkHeader}>
              {proTraderDetails?.status?.curLevel}
            </Text>
            <Text style={styles.levelBlkHeader}>
              {proTraderDetails?.status?.curLevelReward}
            </Text>
          </View>
          <View style={{ marginVertical: 15 }}>
            {proTraderDetails?.status?.curShares >= 0 && (
              <Progress.Bar
                progress={
                  proTraderDetails?.status?.curShares /
                  proTraderDetails?.status?.nextLevelShares
                }
                width={Width.width - 80}
                height={15}
                color={
                  proTraderDetails?.status?.curShares === 0
                    ? "#D9D9D9"
                    : Colors.tradexBlue
                }
                borderRadius={100}
                unfilledColor={"#D9D9D9"}
                borderColor={"#D9D9D9"}
              />
            )}
          </View>

          {proTraderDetails?.status?.nextLevel && (
            <View
              style={{ flexDirection: "row", justifyContent: "space-between" }}
            >
              <Text style={styles.levelBlkFooter}>
                {proTraderDetails?.status?.nextLevel}
              </Text>
              <Text style={styles.levelBlkFooter}>
                {proTraderDetails?.status?.curShares}/
                {proTraderDetails?.status?.nextLevelShares}
              </Text>
            </View>
          )}
            <FormTextLabel
              labelStyles={styles.timeResetText}
              label={"Level will be reset at "}
              rest={{time: moment(proTraderDetails?.status?.levelResetTime).format("MMMM DD, YYYY [-] hh:mm a")}}
            />
          <View
            style={{
              borderBottomWidth: StyleSheet.hairlineWidth,
              marginVertical: 10,
            }}
          ></View>
          <View
            style={{ flexDirection: "row", justifyContent: "space-between" }}
          >
            <FormTextLabel labelStyles={styles.rowTxt} label={"Total Rewards Earned"}/>
            <Text style={styles.rowTxt}>
              {proTraderDetails?.status?.totalRewardsEarned}
            </Text>
          </View>
        </View>
        <View style={styles.box}>
          <FormTextLabel
            labelStyles={[
              globalFontStyle.appFontSubHeading,
              { color: Colors.black, marginBottom: 10 },
            ]}
            label={"Today's Events"}
          />

          {proTraderDetails?.todayEvents?.length > 0 &&
            proTraderDetails?.todayEvents?.map((item, index) => {
              return (
                <Text
                  style={[globalFontStyle.appFontBody, { color: Colors.black }]}
                  key={index}
                >
                  {item}
                </Text>
              );
            })}
        </View>
        <View style={styles.box}>
          <FormTextLabel
            labelStyles={[
              globalFontStyle.appFontHeading,
              { color: Colors.tradexBlue, marginBottom: 10 },
            ]}
            label={"Terms & Conditions"}
          />
          {proTraderDetails?.termsConditions?.length > 0 &&
            proTraderDetails?.termsConditions?.map((item, index) => {
              return (
                <Text
                  key={index}
                  style={[
                    globalFontStyle.appFontSubText,
                    { color: Colors.black1 },
                  ]}
                >
                  {"\u2022"} {item}
                </Text>
              );
            })}
        </View>
      </View>
    </ScrollView>
  );
};

export default ProTrader;

const styles = StyleSheet.create({
  box: {
    borderRadius: 5,
    borderWidth: 0.75,
    borderColor: "#C2C2C2",
    padding: 22,
    marginTop: 22,
  },
  colStyle: {
    flex: 1,
    flexBasis: 0,
  },
  headerCol: {
    ...globalFontStyle.appFontSubTextBold,
    lineHeight: 19,
    color: Colors.black,
  },
  center: {
    textAlign: "center",
  },
  right: {
    textAlign: "right",
  },
  rowTxt: {
    ...globalFontStyle.appFontSubText,
    lineHeight: 19,
    color: Colors.black1,
  },
  levelBlkHeader: {
    ...globalFontStyle.appFontSubHeading,

    color: Colors.black,
  },
  levelBlkFooter: {
    ...globalFontStyle.appFontSubText,

    color: Colors.black,
  },
  timeResetText: {
    ...globalFontStyle.appFontSubText,
    marginTop: 15,
    color: Colors.grey2,
  },
});
